import { render, staticRenderFns } from "./SendSmsModal.vue?vue&type=template&id=15ddf022&scoped=true&"
import script from "./SendSmsModal.vue?vue&type=script&lang=js&"
export * from "./SendSmsModal.vue?vue&type=script&lang=js&"
import style0 from "./SendSmsModal.vue?vue&type=style&index=0&id=15ddf022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ddf022",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ddf022')) {
      api.createRecord('15ddf022', component.options)
    } else {
      api.reload('15ddf022', component.options)
    }
    module.hot.accept("./SendSmsModal.vue?vue&type=template&id=15ddf022&scoped=true&", function () {
      api.rerender('15ddf022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/SendSmsModal.vue"
export default component.exports